import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LastActivePageService {
  constructor() {}

  public storeLastActivePage(url: string): void {
    const lastActivePage = this.getLastActivePage();
    if (url == lastActivePage) {
      this.clearLastActivePage();
      return;
    }
    localStorage.setItem('redirectUrl', url);
  }

  public getLastActivePage(): string | null {
    return localStorage.getItem('redirectUrl');
  }

  public clearLastActivePage(): void {
    localStorage.removeItem('redirectUrl');
  }
}
